import { Box, Button, Container, DropdownMenu, Flex, Heading, TabNav } from "@radix-ui/themes";
import {HomeIcon, PlusCircledIcon, BackpackIcon, ListBulletIcon, ExitIcon, EnterIcon, ChatBubbleIcon, PersonIcon, ReaderIcon} from '@radix-ui/react-icons'
import React, { ReactNode, useEffect, useState } from "react";
import { PUBLIC_ROUTES, ROUTES } from "../../../routes/constants";
import useLogout from '../../../core/services/hooks/useLogout'
import {useAppSelector} from '../../../core/store'
import { IUser } from "../../../core/types/services-types/user-types";
import { Link } from "react-router";

export interface MainLayoutProps {
    children: ReactNode
}



export default function MainLayout(props: MainLayoutProps) {

    const {logout, isLoading, error, errors} = useLogout()
    const userData = useAppSelector(store => store.user.user)
    const exitSession = async () => {
        await logout()
    }
    return (
       <Box>
                <Flex className="p-4 shadow-lg" gap={'3'} align={'end'} justify={'between'} wrap={'wrap'} style={{backgroundColor: 'white'}}>
                <Heading>
                    <Link color='orange' to={'/'} className="!border-none !hover:border-none"> 
                    Рассвет
                    </Link>
                    </Heading>
                <TabNav.Root className="flex-wrap gap-3 items-center justify-center !p-3">



            <Link to="/" className="!p-0" style={{color: 'black', textDecoration: 'none'}}>
            <Flex gap={'1'} align={'center'} justify={'center'}> 
		        <HomeIcon /> Главная
                </Flex>
	        </Link>


	<DropdownMenu.Root>
	<DropdownMenu.Trigger style={{cursor: 'pointer'}}>
		<Flex align={'center'} justify={'center'} gap={'1'}> 
        <DropdownMenu.TriggerIcon />
		Аккаунт
        </Flex>
	</DropdownMenu.Trigger>
	<DropdownMenu.Content>
		<DropdownMenu.Item>
            <Link to={ROUTES.ACCOUNT_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}> 
            <PersonIcon />
            Профиль
            </Flex>
            </Link>
            </DropdownMenu.Item>
		<DropdownMenu.Item>
            <Link to={ROUTES.CHATS_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}>
           <ChatBubbleIcon />
            Чаты
            </Flex>
            </Link>
            </DropdownMenu.Item>
	</DropdownMenu.Content>
</DropdownMenu.Root>





<DropdownMenu.Root>
	<DropdownMenu.Trigger>
	<Flex align={'center'} justify={'center'} gap={'1'} style={{cursor: 'pointer'}}> 
        <DropdownMenu.TriggerIcon />
		Финансы
        </Flex>
	</DropdownMenu.Trigger>
	<DropdownMenu.Content>
		<DropdownMenu.Item>
            <Link to={ROUTES.TRANSACTIONS_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}> 
            <ReaderIcon/>
            Транзакции
            </Flex>
            </Link>
            </DropdownMenu.Item>
		<DropdownMenu.Item>
            <Link to={ROUTES.ADD_BALANCE_RUB_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}>
            <PlusCircledIcon />
            Пополнить баланс
            </Flex>
            </Link>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
            <Link to={ROUTES.ACCOUNT_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}>
            <BackpackIcon />
            Кошелек
            </Flex>
            </Link>
            </DropdownMenu.Item>
	</DropdownMenu.Content>
</DropdownMenu.Root>


<DropdownMenu.Root>
	<DropdownMenu.Trigger>
    <Flex align={'center'} justify={'center'} gap={'1'} style={{cursor: 'pointer'}}> 
        <DropdownMenu.TriggerIcon />
		Для пользователей
        </Flex>
	</DropdownMenu.Trigger>
	<DropdownMenu.Content>
		<DropdownMenu.Item>
            <Link to={PUBLIC_ROUTES.CURRENCIES_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}> 
            <ReaderIcon/>
            Курсы валют
            </Flex>
            </Link>
            </DropdownMenu.Item>
		<DropdownMenu.Item>
            <Link to={PUBLIC_ROUTES.VACANCY_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}>
            <PlusCircledIcon />
            Я согласен(на) на эту работу
            </Flex>
            </Link>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
            <Link to={PUBLIC_ROUTES.IMPORTANT_ROUTE}> 
            <Flex gap={'1'} align={'center'} justify={'center'}>
            <BackpackIcon />
            Важно!
            </Flex>
            </Link>
            </DropdownMenu.Item>
	</DropdownMenu.Content>
</DropdownMenu.Root>




{ userData ? 
<Flex gap={'1'} align={'center'} justify={'center'} onClick={async () => await exitSession()} className="!p-0" style={{cursor: 'pointer'}}> 
<ExitIcon /> Выйти
</Flex>
: 
<Link to={ROUTES.LOGIN_ROUTE} className="!p-0" style={{color: 'black', textDecoration: 'none'}}>
<Flex gap={'1'} align={'center'} justify={'center'}> 
<EnterIcon /> Вход
</Flex>
</Link>
}

         
</TabNav.Root>
                </Flex>
<hr />

     
                
            {props.children}
         
       </Box>
    )
}